/* FÔTE — interactions. Aucun framework, aucune dépendance : tout fonctionne aussi sans JS (dégradation propre). */
(() => {
  'use strict';
  const F = window.FOTE || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const store = {
    get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  };

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) {
    const t = $('.toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(() => (t.hidden = true), 3200);
  }

  /* ---------- Focus trap pour panneaux ---------- */
  function trap(el, e) {
    if (e.key !== 'Tab') return;
    const f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(n => n.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  const lock = on => { document.documentElement.style.overflow = on ? 'hidden' : ''; };

  /* ---------- 1. Intro : la page se construit ---------- */
  function intro() {
    const el = $('.intro'); if (!el) return;
    const key = 'fote:intro';
    const seen = F.settings && F.settings.introOncePerSession ? store.get(key, true) : store.get(key);
    if (seen || reduced) { el.remove(); return; }
    lock(true);
    el.hidden = false;
    let done = false;
    const end = () => {
      if (done) return; done = true;
      F.settings && F.settings.introOncePerSession ? store.set(key, 1, true) : store.set(key, 1);
      el.classList.add('is-leaving');
      lock(false);
      document.dispatchEvent(new CustomEvent('fote:intro-end'));
      setTimeout(() => el.remove(), 900);
    };
    requestAnimationFrame(() => el.classList.add('is-playing'));
    const t = setTimeout(end, 2500);
    $('.intro__skip', el).addEventListener('click', () => { clearTimeout(t); end(); });
    document.addEventListener('keydown', function k(e) { if (e.key === 'Escape') { clearTimeout(t); end(); document.removeEventListener('keydown', k); } });
    $('.intro__skip', el).focus({ preventScroll: true });
  }

  /* ---------- 2. Révélations au défilement ---------- */
  function reveals(root = document) {
    const els = $$('[data-reveal], .mark, .margin-rule, [data-inview]', root);
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(e => e.classList.add('is-inview')); return; }
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    els.forEach(e => io.observe(e));
  }

  /* ---------- 3. Parallaxe subtile (transform uniquement, rAF) ---------- */
  function parallax() {
    if (reduced) return;
    const items = $$('[data-parallax]'); if (!items.length) return;
    let ticking = false;
    const vh = () => window.innerHeight;
    const update = () => {
      items.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh()) return;
        const speed = parseFloat(el.dataset.parallax) || 0.12;
        const p = (r.top + r.height / 2 - vh() / 2) / vh();
        el.style.transform = `translate3d(0, ${(-p * speed * 100).toFixed(2)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- 4. Header ---------- */
  function header() {
    const wrap = $('.header-wrap'); if (!wrap) return;
    const overlay = wrap.classList.contains('header-wrap--overlay');
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (overlay) wrap.classList.toggle('is-solid', y > window.innerHeight * 0.75);
      if (!document.body.classList.contains('menu-open') && !wrap.matches(':focus-within')) {
        wrap.classList.toggle('is-hidden', y > last && y > 400);
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    const sheet = $('#MenuSheet');
    if (!sheet) return;
    const openBtns = $$('[data-menu-open]'), closeBtn = $('[data-menu-close]', sheet);
    let opener;
    const open = () => {
      opener = document.activeElement;
      sheet.hidden = false;
      requestAnimationFrame(() => sheet.classList.add('is-open'));
      sheet.setAttribute('aria-hidden', 'false');
      openBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('menu-open'); lock(true);
      setTimeout(() => closeBtn && closeBtn.focus(), 50);
    };
    const close = () => {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      openBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('menu-open'); lock(false);
      opener && opener.focus();
    };
    openBtns.forEach(b => b.addEventListener('click', open));
    closeBtn && closeBtn.addEventListener('click', close);
    sheet.addEventListener('keydown', e => { if (e.key === 'Escape') close(); trap(sheet, e); });
  }

  /* ---------- 5. Curseur : le crayon rouge ----------
     Le crayon suit la souris au pixel près (sa mine EST le pointeur) ;
     la pastille « VOIR / DÉCOUVRIR » suit avec un léger retard, comme une encre qui s'étale. */
  function cursor() {
    if (!F.settings || !F.settings.cursor || !fine || reduced) return;
    const c = $('.cursor'); if (!c) return;
    const pencil = $('.cursor__pencil', c), disc = $('.cursor__disc', c), label = $('.cursor__label', c);
    document.documentElement.classList.add('has-cursor');
    let x = -100, y = -100, dx = x, dy = y, raf;
    const loop = () => {
      dx += (x - dx) * 0.2; dy += (y - dy) * 0.2;
      disc.style.transform = `translate3d(${dx}px, ${dy}px, 0)`;
      raf = Math.abs(x - dx) + Math.abs(y - dy) > 0.1 ? requestAnimationFrame(loop) : null;
    };
    window.addEventListener('pointermove', e => {
      x = e.clientX; y = e.clientY;
      pencil.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    window.addEventListener('pointerdown', () => c.classList.add('is-down'));
    window.addEventListener('pointerup', () => c.classList.remove('is-down'));
    const states = ['is-link', 'is-media', 'is-red', 'is-drag', 'is-hidden'];
    const set = (s, txt = '') => { c.classList.remove(...states); if (s) c.classList.add(s); if (txt) label.textContent = txt; };
    document.addEventListener('pointerover', e => {
      const t = e.target;
      if (t.closest('input, textarea, select, iframe, .shopify-payment-button, [data-cursor=none]')) return set('is-hidden');
      const d = t.closest('[data-cursor]');
      if (d) {
        const v = d.dataset.cursor;
        if (v === 'red') return set('is-red');
        if (v === 'drag') return set('is-drag', d.dataset.cursorLabel || '← →');
        return set('is-media', d.dataset.cursorLabel || v);
      }
      if (t.closest('a, button, label, summary, [role=button]')) set('is-link'); else set('');
      c.classList.toggle('is-btn', !!t.closest('.btn:not([disabled])'));
    });
    document.addEventListener('pointerleave', () => set('is-hidden'));
    document.addEventListener('pointerenter', () => set(''));
  }

  /* ---------- 6. Dialogues natifs (histoire, guide des tailles) ---------- */
  function dialogs() {
    document.addEventListener('click', e => {
      const o = e.target.closest('[data-dialog-open]');
      if (o) {
        const d = document.getElementById(o.dataset.dialogOpen);
        if (d && d.showModal) { e.preventDefault(); d.showModal(); lock(true); }
      }
      const c = e.target.closest('[data-dialog-close]');
      if (c) { const d = c.closest('dialog'); d && d.close(); }
    });
    $$('dialog').forEach(d => {
      d.addEventListener('close', () => lock(false));
      d.addEventListener('click', e => { if (e.target === d) d.close(); }); // clic hors de la feuille
    });
  }

  /* ---------- 7. Panier ---------- */
  const Cart = {
    drawer: null,
    init() {
      this.drawer = $('#CartDrawer');
      document.addEventListener('click', e => {
        const t = e.target.closest('[data-cart-open]');
        if (t && this.drawer && F.settings.cartType === 'drawer') { e.preventDefault(); this.open(); }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); this.close(); }
        const rm = e.target.closest('[data-line-remove]');
        if (rm) { e.preventDefault(); this.change(rm.dataset.key, 0, rm.closest('[data-line]')); }
      });
      document.addEventListener('change', e => {
        const q = e.target.closest('[data-line-qty]');
        if (q) this.change(q.dataset.key, parseInt(q.value, 10) || 0, q.closest('[data-line]'));
      });
      if (this.drawer) {
        this.drawer.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); trap(this.drawer, e); });
      }
    },
    open() {
      const d = this.drawer; if (!d) return;
      this.opener = document.activeElement;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true);
      setTimeout(() => { const f = $('[data-cart-close]', d); f && f.focus(); }, 60);
    },
    close() {
      const d = this.drawer; if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lock(false);
      this.opener && this.opener.focus();
    },
    sectionsToRender() {
      const ids = ['cart-drawer'];
      $$('[data-cart-section]').forEach(el => ids.push(el.dataset.cartSection));
      return [...new Set(ids)];
    },
    render(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(id => {
        const html = sections[id]; if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          const fresh = $('[data-drawer-inner]', doc), cur = $('[data-drawer-inner]');
          if (fresh && cur) cur.replaceWith(fresh);
        } else {
          const fresh = $(`[data-cart-section="${id}"]`, doc), cur = $(`[data-cart-section="${id}"]`);
          if (fresh && cur) cur.replaceWith(fresh);
        }
      });
      const inner = $('[data-drawer-inner]');
      const count = inner ? inner.dataset.count : null;
      if (count !== null) $$('[data-cart-count]').forEach(c => (c.textContent = count));
      reveals($('[data-drawer-inner]') || document);
    },
    async add(formData) {
      formData.append('sections', this.sectionsToRender().join(','));
      formData.append('sections_url', window.location.pathname);
      const res = await fetch(F.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || F.strings.cartError);
      this.render(data.sections);
      return data;
    },
    async change(key, quantity, line) {
      line && line.classList.add('is-updating');
      try {
        const res = await fetch(F.routes.cartChange + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: this.sectionsToRender(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || F.strings.cartError);
        this.render(data.sections);
        // Quantité demandée > stock : Shopify plafonne, on prévient.
        const item = (data.items || []).find(i => i.key === key);
        if (item && quantity > item.quantity) {
          const fresh = $(`[data-line][data-key="${key}"] .line-item__error`);
          if (fresh) { fresh.hidden = false; }
          toast(F.strings.cartError);
        }
      } catch (err) {
        line && line.classList.remove('is-updating');
        const e = line && $('.line-item__error', line);
        if (e) { e.textContent = err.message; e.hidden = false; } else toast(err.message);
      }
    }
  };

  /* ---------- 8. Fiche produit ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root;
      const json = $('[data-product-json]', root);
      this.product = json ? JSON.parse(json.textContent) : null;
      this.form = $('form[data-product-form]', root);
      this.idInput = this.form && $('input[name="id"]', this.form);
      this.btn = this.form && $('[data-add]', this.form);
      this.err = $('[data-form-error]', root);
      if (!this.product || !this.form) return;
      root.addEventListener('change', e => { if (e.target.closest('[data-option]')) this.onOption(); });
      this.form.addEventListener('submit', e => this.submit(e));
      this.markAvailability();
      $$('[data-qty]', root).forEach(q => {
        const input = $('input', q);
        $$('button', q).forEach(b => b.addEventListener('click', () => {
          const v = Math.max(1, (parseInt(input.value, 10) || 1) + (b.dataset.step === '+' ? 1 : -1));
          input.value = v;
        }));
      });
    }
    selected() {
      return $$('[data-option]', this.root).map(f => {
        const s = $('select', f); if (s) return s.value;
        const c = $('input:checked', f); return c ? c.value : null;
      });
    }
    findVariant(opts) {
      return this.product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    markAvailability() {
      const sel = this.selected();
      $$('[data-option]', this.root).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const v = this.findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
        const val = $('[data-option-value]', fs);
        if (val) val.textContent = sel[idx] || '';
      });
    }
    onOption() {
      const v = this.findVariant(this.selected());
      this.markAvailability();
      this.err && (this.err.hidden = true);
      if (!v) { this.setButton(false, F.strings.unavailable); this.updateStock(null); return; }
      this.idInput.value = v.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      this.setButton(v.available, v.available ? F.strings.addToCart : F.strings.soldOut);
      this.updatePrice(v); this.updateStock(v);
      if (v.featured_media) this.goToMedia(v.featured_media.id);
    }
    setButton(ok, text) {
      if (!this.btn) return;
      this.btn.disabled = !ok;
      $('[data-add-label]', this.btn).textContent = text;
    }
    money(cents) {
      const fmt = this.product.money_format || '{{amount_with_comma_separator}} €';
      const v = (cents / 100).toFixed(2);
      const [i, d] = v.split('.');
      const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + d;
      const dot = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k.includes('comma') ? (k.includes('no_decimals') ? comma.split(',')[0] : comma) : (k.includes('no_decimals') ? dot.split('.')[0] : dot));
    }
    updatePrice(v) {
      const p = $('[data-price]', this.root); if (!p) return;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        p.classList.add('price--sale');
        p.innerHTML = `<s>${this.money(v.compare_at_price)}</s><ins>${this.money(v.price)}</ins>`;
      } else { p.classList.remove('price--sale'); p.textContent = this.money(v.price); }
    }
    updateStock(v) {
      const s = $('[data-stock]', this.root); if (!s) return;
      const inv = v && this.product.inventory ? this.product.inventory[v.id] : null;
      s.className = 'stock';
      if (!v) { s.classList.add('stock--out'); s.textContent = F.strings.unavailable; return; }
      if (!v.available) { s.classList.add('stock--out'); s.textContent = s.dataset.out; return; }
      if (inv && inv.managed && inv.qty > 0 && inv.qty <= (parseInt(s.dataset.threshold, 10) || 3)) {
        s.classList.add('stock--low'); s.textContent = s.dataset.low.replace('[n]', inv.qty); return;
      }
      s.textContent = s.dataset.in;
    }
    goToMedia(id) {
      const m = $(`[data-media-id="${id}"]`, this.root); if (!m) return;
      const g = m.parentElement;
      if (window.matchMedia('(max-width: 989px)').matches) g.scrollTo({ left: m.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      else if (g.firstElementChild !== m) g.prepend(m);
    }
    async submit(e) {
      if (!window.fetch || !$('#CartDrawer')) return; // repli : envoi classique vers /cart
      e.preventDefault();
      if (this.btn.disabled) return;
      this.btn.classList.add('is-loading'); this.btn.setAttribute('aria-busy', 'true');
      this.err && (this.err.hidden = true);
      try {
        await Cart.add(new FormData(this.form));
        Cart.open();
      } catch (err) {
        if (this.err) { this.err.textContent = err.message; this.err.hidden = false; } else toast(err.message);
      } finally {
        this.btn.classList.remove('is-loading'); this.btn.removeAttribute('aria-busy');
      }
    }
  }

  function gallery(root) {
    const g = $('[data-gallery]', root); if (!g) return;
    const dots = $$('.product__dots span', root);
    if (dots.length) {
      g.addEventListener('scroll', () => {
        const i = Math.round(g.scrollLeft / g.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, { passive: true });
    }
    const zoom = $('[data-zoom-dialog]', root); if (!zoom) return;
    const track = $('.zoom-dialog__track', zoom);
    $$('button.zoom', g).forEach(b => b.addEventListener('click', () => {
      zoom.showModal(); lock(true);
      const slide = $(`[data-zoom-for="${b.dataset.index}"]`, zoom);
      slide && track.scrollTo({ left: slide.offsetLeft });
    }));
    $$('.zoom-dialog__slide', zoom).forEach(s => {
      s.addEventListener('click', e => {
        const img = $('img', s);
        if (!s.classList.contains('is-zoomed')) {
          const r = img.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        }
        s.classList.toggle('is-zoomed');
      });
      s.addEventListener('pointermove', e => {
        if (!s.classList.contains('is-zoomed') || e.pointerType !== 'mouse') return;
        const img = $('img', s), r = s.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      });
    });
    zoom.addEventListener('close', () => $$('.is-zoomed', zoom).forEach(s => s.classList.remove('is-zoomed')));
  }

  /* ---------- 9. Ajout rapide depuis une carte (variante unique) ---------- */
  function quickAdd() {
    document.addEventListener('submit', async e => {
      const f = e.target.closest('form[data-quick-add]');
      if (!f || !$('#CartDrawer')) return;
      e.preventDefault();
      const b = $('button', f); b.classList.add('is-loading');
      try { await Cart.add(new FormData(f)); Cart.open(); }
      catch (err) { toast(err.message); }
      finally { b.classList.remove('is-loading'); }
    });
  }

  /* ---------- 10. Filtres de collection : envoi automatique ---------- */
  function filters() {
    $$('form[data-filters]').forEach(f => {
      f.addEventListener('change', () => {
        const params = new URLSearchParams(new FormData(f));
        window.location.search = params.toString();
      });
    });
  }

  /* ---------- 11. Défilement horizontal au glisser (souris) ---------- */
  function dragScroll() {
    if (!fine) return;
    $$('[data-drag-scroll]').forEach(el => {
      let down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
      window.addEventListener('pointerup', () => { down = false; });
      el.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = sl - dx; });
      el.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- 12. Recommandations produit (chargées à l'approche) ---------- */
  function recs() {
    $$('[data-recs]').forEach(el => {
      const load = async () => {
        try {
          const r = await fetch(el.dataset.url); const html = await r.text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; reveals(el); }
        } catch (e) {}
      };
      if (!('IntersectionObserver' in window)) return load();
      const io = new IntersectionObserver(en => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
      io.observe(el);
    });
  }

  /* ---------- Init ---------- */
  function init() {
    intro();
    reveals();
    // Le hero se révèle dès l'arrivée (ou à la fin de l'introduction)
    const heroIn = () => $$('.hero [data-reveal]').forEach((e, i) => setTimeout(() => e.classList.add('is-inview'), 120 + i * 140));
    $('.intro.is-playing') ? document.addEventListener('fote:intro-end', heroIn, { once: true }) : heroIn();
    parallax();
    header();
    cursor();
    dialogs();
    Cart.init();
    quickAdd();
    filters();
    dragScroll();
    recs();
    $$('[data-product]').forEach(r => { new ProductForm(r); gallery(r); });
    // Panier : ouvrir automatiquement après un ajout classique (?cart=open)
    if (new URLSearchParams(location.search).get('cart') === 'open') Cart.open();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  // Éditeur de thème : réinitialiser les sections rechargées
  document.addEventListener('shopify:section:load', e => {
    reveals(e.target); parallax();
    $$('[data-product]', e.target).forEach(r => { new ProductForm(r); gallery(r); });
  });
  window.FOTE.cart = Cart;
})();
